import React, { useState } from 'react'
import Classes from './Faq.module.css'
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';

export default function Faq() {
    const navigateTo = useNavigate();
    const [expanded, setExpanded] = useState('panel1');
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            question: "How does Mentr connect mentees with the right mentors?",
            answer: "Mentr helps mentees find the right mentors by using filters such as industry, experience level, skills, and personal goals. This ensures each match is relevant, so mentees connect with mentors who can offer the most value based on their specific needs. Mentees can also search and select their own mentors directly, without needing to be matched, giving them full control over their mentorship journey."
        },
        {
            question: "What qualifications do mentors need to join the platform?",
            answer: "Mentors must have relevant industry experience, a proven track record of success, and a genuine interest in helping others grow. We prioritize professionals with entrepreneurial, executive, or subject-matter expertise who can offer practical advice and guidance."
        },
        {
            question: "How do mentors set their availability and pricing?",
            answer: "Mentors set their availability and pricing directly in their profile builder. They can choose the days, times, and rates that work best for them, and update their settings at any time."
        },
        {
            question: "Can mentees reschedule or cancel booked sessions?",
            answer: <>
                Yes, mentees can reschedule or cancel sessions through the calendar link provided by the mentor, such as Calendly, Cal.com, or Zoom. Changes are subject to the mentor’s rescheduling and cancellation policy.
            </>
        },
        {
            question: "How does Mentr handle payments between mentees and mentors?",
            answer: "All payments are processed securely through Stripe. Mentees pay a $5.00 flat fee + rate each meeting. Mentr charges mentors a 20% fee on each completed session."
        },
    ];

    return (
        <>
            <section id='faq' className={Classes.section}>
                <div>
                    <div className={Classes.miniText} > FAQS </div>
                    <h1 className={Classes.subheading}> Frequently Asked <br /> Questions </h1>
                    <p className={Classes.text} >
                        Find answers to common questions about <br className={Classes.br1} /> connecting with mentors or earning from mentorship. <br className={Classes.br2} /> Need more help?
                        <span onClick={() => { navigateTo('/contact-us') }} style={{ color: '#F26A63', fontWeight: '600', cursor: 'pointer' }} > Contact us</span>.
                    </p>
                </div>

                <div id='questions' className={Classes.faqs}>
                    <div className={Classes.faqsCon}>
                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === `panel${index + 1}`}
                                onChange={handleChange(`panel${index + 1}`)}
                                sx={{
                                    border: '1px solid #80808024',
                                    boxShadow: 'rgb(0 0 0 / 13%) 0px 1px 2px',
                                    marginBottom: '1rem',
                                    borderRadius: '7px !important',
                                    padding: '6px 20px !important',
                                    '&:before': {
                                        display: 'none',
                                    }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index + 1}bh-content`}
                                    id={`panel${index + 1}bh-header`}
                                    sx={{
                                        minHeight: '32px !important',
                                        margin: '0 !important',
                                        padding: '0px 10px !important',
                                        '&.Mui-expanded': {
                                            margin: '0 !important',
                                            minHeight: '32px !important',
                                            padding: '0px 10px !important',
                                        },
                                        '.MuiAccordionSummary-content': {
                                            margin: '10px 0 !important'
                                        },
                                        '.MuiAccordionDetails-root': {
                                            padding: '8px 12px 16px !important'
                                        },
                                    }}
                                >
                                    <div className={Classes.AccordionHeader}>
                                        <h5>{faq.question}</h5>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className={Classes.accordinBody}
                                    sx={{
                                        padding: '8px 16px 16px 10px !important',
                                    }}
                                >
                                    <h5 className={Classes.accordionText}>{faq.answer}</h5>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>
                </div>

            </section>
        </>
    )
}
